import type { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { selectIsAuthenticated } from "@/store/authSlice";
import { useAppSelector } from "@/store";

interface Props {
  children: ReactElement;
}

export function ProtectedRoute({ children }: Props) {
  const isAuth = useAppSelector(selectIsAuthenticated);
  const location = useLocation();
  if (!isAuth) {
    // Preserve the attempted URL so login can redirect back after success.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
